<template>
    <div class="modal fade" id="modalEvolucion" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Evoluciones</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="alert alert-warning mt-2" v-if="!evoluciones.length">
                        No se han cargado evoluciones...
                    </div>
                    <div v-else class="card mt-2 border-gray-500 shadow-none" v-for="item in evoluciones" :key="item.id">
                        <div class="card-header bg-light">
                            <div class="row">
                                <div class="col-4 ">
                                    Evolución No. {{item.id}} 
                                </div>
                                <div class="col-8 d-flex justify-content-end">
                                    <span class="text-danger mx-2">{{item.user.name}}</span> ({{item.fecha | formatDate}} {{item.hora | formatTime}})
                                </div>
                            </div>
                        </div>
                        <div class="card-body" >
                            <div class="btn-group shadow-sm float-right" role="group" >
                                <button @click="ver(item.id)" class="btn btn-outline-primary btn-xs" >
                                    <i class="fa fa-eye fa-fw"></i> Ver Evolución
                                </button>
                                <button @click="imprimir(item.id)" class="btn btn-outline-success btn-xs" >
                                    <i class="fa fa-print fa-fw"></i> Imprimir
                                </button>
                                <button v-if="item.id_user===user.id" @click="eliminarEvolucion(item.id)" class="btn btn-outline-danger btn-xs" >
                                    <i class="fa fa-trash-alt"></i> Eliminar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Cerrar</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import urgenciaEvolucionService from "../../../../services/urgenciaEvolucionService";
import $ from 'jquery';
import Toast from '../../../../components/common/utilities/toast';
import Swal from 'sweetalert2';
export default {
    props: ['evoluciones', 'idUsuario'],
    methods: {
        async eliminarEvolucion(id) {
            const result = await Swal.fire({
                title :  "¿Quiere eliminar esta evolución?",
                text : "Esta opción no es reversible",
                showCancelButton : true,
                showConfirmButton : true,
                confirmButtonText : 'Sí, Eliminar',
                cancelButtonText : 'No',
                icon : "question",
                showLoaderOnConfirm : true,
                preConfirm: async () => {
                    try{
                        this.LoaderSpinnerShow();
                        await urgenciaEvolucionService.delete(id);
                        this.LoaderSpinnerHide();
                    }catch (e) {
                        console.error(e);
                        this.LoaderSpinnerHide();
                        Swal.showValidationMessage('ha ocurrido un error al procesar la solicitud');
                    }
                },
            });

            if(result.isConfirmed){
                Toast.fire({
                    icon: 'success',
                    title: 'Datos eliminados con exito'
                });
                $('#modalEvolucion').modal('hide');
            } 
        },
        ver(id) {
            $('#modalEvolucion').modal('hide');
            this.$router.push({
                name: 'ver.evoluciones.urgencia',
                params: { 'id': id }
            })
        },
        imprimir(id){
            window.open(urgenciaEvolucionService.print(id));
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        }
    }
}
</script>

